// extracted by mini-css-extract-plugin
export default {"wrap":"index_wrap_J7ZSA","wrapPic":"index_wrapPic_xcrS5","wrapText":"index_wrapText_wQeB6"};